import { Parser } from 'json2csv';

export const convertJSONtoCSV = (fields: string[], jsonFile: Record<string, any>[]) => {
  const opts = { fields };

  try {
    const parser = new Parser(opts);
    const csv = parser.parse(jsonFile);
    console.log('Total CSV Rows: ', csv.length);
    console.log(csv);
    return csv;
  } catch (err) {
    console.error(err);
  }
};

export const downloadFile = (file: any, filename: string) => {
  const link = document.createElement('a');
  if (file == null) return;

  if (!file.match(/^data:text\/csv/i)) {
    file = `data:text/csv;charset=utf-8,${file}`;
  }
  const u8arr = new TextEncoder().encode(file);
  const url = window.URL.createObjectURL(new Blob([u8arr], { type: 'text/csv' }));
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.click();
};

export const convertBase64ToFile = async (base64String: string, filename: string, type: { type: string } = { type: 'image/jpeg' }) => {
  const res = await fetch(base64String);
  const blob = await res.blob();
  return new File([blob], filename, type);
};
